import BaseService from './BaseService';

class CoreService extends BaseService {
	constructor() {
		super('');
	}

	getSettings() {
		return this.get('/settings');
	}

	publicSettings() {
		return this.get('/publicSettings');
	}
}

export default new CoreService();
